import themes from 'devextreme/ui/themes';
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-licence';
 

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

config({ licenseKey });   

// 🚀 OPTIMISATION: Bootstrap non-bloquant - themes chargés en parallèle
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    // Themes initialisés après le bootstrap pour éviter le blocage
    themes.initialized(() => {
      console.log('🎨 DevExtreme themes chargés');
    });
  })
  .catch(err => console.error(err));